<template>
  <div class="about-page">
    <CompanyIntroduction />
    <DevelopmentProcess />
    <ParkingBusinessList />
    <ParkingTypes />
    <PerformanceComparison />
    <ContactFooter />
  </div>
</template>

<script>
import CompanyIntroduction from '@/components/about/CompanyIntroduction.vue'
import DevelopmentProcess from '@/components/about/DevelopmentProcess.vue'
import ParkingBusinessList from '@/components/about/ParkingBusinessList.vue'
import ParkingTypes from '@/components/about/ParkingTypes.vue'
import PerformanceComparison from '@/components/about/PerformanceComparison.vue'
import ContactFooter from '@/components/ContactFooter.vue'

export default {
  name: 'AboutPage',
  components: {
    CompanyIntroduction,
    DevelopmentProcess,
    ParkingBusinessList,
    ParkingTypes,
    PerformanceComparison,
    ContactFooter
  }
}
</script>

<style scoped>
.about-page {
  padding: 0px;
  margin: 0px;  
  background-color: var(--background-gray);
  /* background-color: #111111; */
  /* background-color: #; */
}


</style>
